import { Component, OnInit, Input } from '@angular/core';
import { ScreenUtils } from 'src/app/utils/screen.utils';
import { BaggageDetails } from '../../shared/models/domain/baggage-details';

@Component({
  selector: 'ds-cluster-amenities',
  templateUrl: './cluster-amenities.component.html',
  styleUrls: ['./cluster-amenities.component.scss']
})
export class ClusterAmenitiesComponent implements OnInit {

  @Input() baggageDetails: BaggageDetails;
  isMobile: boolean = ScreenUtils.isMobile();


  constructor() { }

  ngOnInit() {
  }

}
